import { XMarkIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import Button from "components/buttons/Button/Button";

import { ActionBlockButton } from "~/components/buttons/ActionBlockButton";
import type { TimeTrackingExtendedType } from "~/modules/timeTracking/api/timeTracking/timeTrackingTypes.ts";
import { TimeTrackingTypeId } from "~/modules/timeTracking/api/timeTrackingType/timeTrackingTypeTypes.ts";

type Props = {
	data: TimeTrackingExtendedType;
	onClickDelete: () => void;
	onClickEdit: () => void;
	onClickClose: () => void;
};

export function Details({
	data: {
		delete: deleteBlock,
		isBillable,
		projectTitle,
		projectPhaseTitle,
		orderTitle,
		locationName,
		text,
		timeTrackingTypeId,
		update: updateBlock,
	},
	onClickDelete,
	onClickEdit,
	onClickClose,
}: Props) {

	const title = () => {
		if (timeTrackingTypeId === TimeTrackingTypeId.Project) {
			return projectTitle;
		}

		if (timeTrackingTypeId === TimeTrackingTypeId.Internal) {
			return "Intern";
		}

		if (timeTrackingTypeId === TimeTrackingTypeId.Sales) {
			return "Sales";
		}

		if (timeTrackingTypeId === TimeTrackingTypeId.PartTime) {
			return "Teilzeit";
		}
	};
	const isProject = timeTrackingTypeId === TimeTrackingTypeId.Project;
	return (
		<div className="w-full">
			<div className="flex justify-between">
				<div className="font-bold">
					{title()}
				</div>
				<div className="flex items-center">
					<ActionBlockButton block={updateBlock}
									   theme="accent"
									   onClick={onClickEdit}
									   size="sm">
						bearbeiten
					</ActionBlockButton>
					<ActionBlockButton block={deleteBlock}
									   className="ml-2"
									   theme="danger"
									   onClick={onClickDelete}
									   size="sm">
						löschen
					</ActionBlockButton>
					<Button size="sm"
							theme="none"
							onClick={onClickClose}>
						<XMarkIcon className="-mr-2 size-5 text-white" />
					</Button>
				</div>
			</div>
			<dl className={clsx("min-w-full divide-y whitespace-pre-line text-sm leading-6", isBillable ? "divide-gray-600": "divide-white/30")}>
				{isProject &&
					<div className={clsx("px-0 py-1", isBillable ? "opacity-60": "opacity-100")}>
						{!isBillable && "NICHT ABRECHENBAR | "}
						<span className="opacity-60">
							Phase:
						</span>
						{` ${projectPhaseTitle} `}
						<span className="opacity-60">
							| PO:
						</span>
						{` ${orderTitle} `}
						<span className="opacity-60">
							| Ort:
						</span>
						{` ${locationName}`}
					</div>}
				<div className="flex flex-row items-start px-0 pt-1">
					<dd className="whitespace-pre-line text-sm">{text || "-"}</dd>
				</div>
			</dl>
		</div>
	);
}
